"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductQueryKeys = exports.SimilarProductsQueryKeys = exports.FavoritesQueryKeys = void 0;
exports.FavoritesQueryKeys = {
    GetAll: (persistenceStrategy) => ['favorites', 'getAll', persistenceStrategy],
    AddItem: (persistenceStrategy) => ['favorites', 'addItem', persistenceStrategy],
    RemoveItem: (persistenceStrategy) => ['favorites', 'removeItem', persistenceStrategy],
};
exports.SimilarProductsQueryKeys = {
    GetBySkus: (skus) => ['similarProducts', 'getBySkus', { skus }],
};
exports.ProductQueryKeys = {
    GetBySkus: (skus, options = {}) => ['product', 'getBySkus', skus, options],
};
